"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var contexts_1 = require("../../contexts/");
var LftIllustration_styles_1 = require("./LftIllustration.styles");
var LftIllustration = function (_a) {
    var alt = _a.alt, illustration = _a.illustration, loading = _a.loading, id = _a.id, _b = _a.size, size = _b === void 0 ? 'md' : _b, _c = _a.variant, variant = _c === void 0 ? 'light' : _c;
    var brand = (0, contexts_1.useBrand)();
    var template = (0, contexts_1.useTemplate)();
    return ((0, jsx_runtime_1.jsx)(LftIllustration_styles_1.IllustrationWrapper, { children: (0, jsx_runtime_1.jsx)("img", { id: id, src: "https://lift.yduqs.com.br/assets/brands/" + brand + "/illustration/" + illustration + "/" + size + "/" + (template === 'high-contrast' ? 'contrast' : variant) + ".svg", alt: alt, loading: loading }, void 0) }, void 0));
};
exports.default = LftIllustration;
